var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"id":"Icon/Filter2","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.8337 1.75H1.16699L5.83366 7.26833V11.0833L8.16699 12.25V7.26833L12.8337 1.75Z","stroke":"#3861FB","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }